import React from 'react';
import styled from 'styled-components';
import theme from '../theme';

const BaseButton = styled.button`
    border-radius: 8px;    
    display: flex;
    justify-content: center;
    align-items: center;
    &:focus {
        outline: none;
    } 
    padding: 0;
`

const SelectButton = styled(BaseButton)`         
    border: solid ${props => props.selected ? '2px' : '1px'} ${props => props.selected ? theme.colors.primary : theme.colors.gray_3};
    background-color: ${theme.colors.gray_0};    
    color: ${theme.colors.gray_9};            
    &:active {
        background-color: ${theme.colors.gray_2};    
    }
    box-shadow: 0 1px 1px 0 rgba(34, 37, 42, 0.07);
`;

export const PrimaryButton = styled(BaseButton)`
    background-color: ${theme.colors.primary};
    color: ${theme.colors.white};
    &:active {
        background-color: ${theme.colors.primary_variant};    
    }        
    border: none;      
    box-shadow: 0 1px 1px 0 rgba(255, 123, 92, 0.5);;
`;

export const CTAButton = (props) => {    
    return (
        <PrimaryButton style={{...props.style}} onClick={props.onClick}> 
            <div 
                style={{
                    marginLeft: props.widthMargin,
                    marginRight: props.widthMargin,
                    fontFamily: 'Montserrat',
                    fontSize: '1rem'                    
                }}>
                {props.children}
            </div>
        </PrimaryButton>
    )            
}

export const ImageTextButton = (props) => {        
    const style = {
        width: '49%', 
        height: '6rem', 
        float: 'left',
        marginRight: props.index % 2 ? '0%' : '1%',
        marginLeft: props.index % 2 ? '1%' : '0%',
        marginBottom: '0.5rem'
    };

    return (
        <SelectButton selected={props.selected} style={style} onClick={props.onClick}>                
            <div>
                <img src={props.imageSrc} alt="button" style={{width: '2.813rem', height: '2.813rem'}}/>
                <div style={{marginTop: '0.25rem', fontSize: '0.875rem'}}>{props.children}</div>
            </div>   
        </SelectButton>
    )    
}

export const TextButton = (props) => {    
    const textSize = props.textSize || '1rem';
    const style = {
        width: '49%', 
        height: '6rem', 
        float: 'left',
        marginRight: props.index % 2 ? '0%' : '1%',
        marginLeft: props.index % 2 ? '1%' : '0%',
        marginBottom: '0.5rem'
    };
    return (
        <SelectButton selected={props.selected} style={style} onClick={props.onClick}>                                                    
            <div style={{fontSize: textSize}}>{props.children}</div>
        </SelectButton>
    )
}
                             
